import {
	PRIVACY_POLICY_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[PRIVACY_POLICY_MODULE_ID]: {
		moduleType: 'static',
		staticPageType: 'privacyPolicy',
	},
}
